import React, { ReactNode, useContext, useState } from 'react';
import { AuthContext } from '../../context/AuthProvider';
import TopBar from './TopBar';
import AsideMenu from './AsideMenu';

interface MenuProps {
    children: ReactNode;
  }

  
const Menu: React.FC<MenuProps> = ({ children }) => {
  const [isAsideOpen, setIsAsideOpen] = useState(true);
  const {user} = useContext(AuthContext)

  return (
    <div className="">
      <div className={`main-header ${isAsideOpen ? 'open': 'collapsed'}`}>
        <TopBar username={user?.firstName? user.firstName: ''} toggleMenu={() => setIsAsideOpen(prev => !prev)} />
      </div>
      <AsideMenu isOpen={isAsideOpen} />
      <main className={`main-container  ${isAsideOpen ? 'open': 'collapsed'}`}>
        {children}
      </main>

    </div>
  );
};

export default Menu;
